import React, { Component } from "react";
import { getToken,getDict } from "utils/storage";
import { Input, Button, Upload, message } from 'antd';
import Request from "../../../../networkReq/request";
import Http from "../../../../networkReq/http";
import uploadIcon from "../../../../img/userCenter/icon_upload_img.png";
import cancelIcon from "../../../../img/userCenter/icon_cancel.png";
import { formConfig } from "./fieldConfig";
import { RenderForm, RenderFormItem, EchoForm } from "./components";
import Nav from "components/Nav";
import { navRouter } from "../fieldConfig";
import './index.scss'
const codeList =  getDict();


function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
        // Message.error("请上传图片");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        // Message.error("图片不能超过2MB!");
    }
    return isJpgOrPng && isLt2M;
}

const uploadProps = {
    name: "file",
    showFileList: false,
    className: "avatar-uploader",
    showUploadList: false,
    headers: {
        Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        "Blade-Auth": getToken(),
    },
    action: "/tyjrmh/api/blade-file/fileServer/uploadSingle",
    beforeUpload: beforeUpload
};

export default class UserInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            resData: {},
            formConfig: formConfig(),
            formConfig1: formConfig(),
            materiList: [],
            materiList1: [],
            informationFormState: '',//审核状态（0提交 1通过 2未通过 3草稿）
            informationFormReason:'',
            isInfoEdit: false,
            isMateriUpload: false,
            areaInfo:{}
        };
    }
    componentWillMount() {
        const token = getToken();
        if (token) {
            this.setState({
                token: token,
            });
        }
        this.getInstitutionInfo() 
        
    }
   
    getInstitutionInfo() {
        let userId = localStorage.getItem('userId')
        let params = { userId };
        Http.get(Request.userInfo1(), params, (obj) => {
            console.log("------userInfo------", obj.data);
            if (obj.code == 200) {
                // codeList.map((option)=>{
                //     if(option.code === "poli_affi_code"){
                //         console.log("option-poli_affi_code",option);
                //         option.children.map((item)=>{
                //             if(obj.data.veteransOutlook == item.dictKey){
                //                 obj.data.veteransOutlook = item.dictValue;
                //             }
                //         })
                //     }
                // })
                
                this.setState({
                    resData: obj.data,
                    formConfig: formConfig(obj.data),
                    formConfig1: formConfig(obj.data),
                    materiList: [...obj.data.sybPhotoManages],
                    materiList1: [...obj.data.sybPhotoManages],
                    informationFormState: obj.data.informationFormState,
                    informationFormReason:obj.data.informationFormReason
                });
            } else {
                // Message.error("登录信息已失效，请重新登录");
                // setTimeout(() => {
                //     this.props.history.push('/login')
                // }, 1000);
            }
        });
    }

    handleChange(value, name) {
        const { formConfig1 } = this.state;
        console.log("------handleChange------", name, value);
        formConfig1.forEach((item) => {
            if (item.name == name) {
                item.value = value;
            }
        });
        this.setState({ formConfig1 });
    }
    handleChange2(value){
        console.log('value',value);
        this.setState({areaInfo:value})
    }
    handleSubmit(e) {
        e.preventDefault();

    }

    handleCancel(type) {
        console.log("------handleCancel------", type);
        const { formConfig, materiList } = this.state;
        // if (type == 'form') {
        //     this.setState({ isInfoEdit: false, formConfig1: [...formConfig] });
        // } else if (type == 'upload') {
        //     this.setState({ isMateriUpload: false, materiList1: [...materiList] });
        // }
        this.setState({ isInfoEdit: false, formConfig1: [...formConfig], materiList1: [...materiList] });
    }

    handleSave(type) {
        console.log("------handleSave------");
        const { formConfig1, materiList1, resData } = this.state;
        if (type == 'form') {
            this.setState({ isInfoEdit: false, formConfig: [...formConfig1] });
        } else if (type == 'upload') {
            this.setState({ isMateriUpload: false, materiList: [...materiList1] });
        }

        if (resData.informationFormState === 0) {
            this.updateInstitutionInfo()
        } else {
            this.authInstitutionInfo()
        }

    }

    authInstitutionInfo() {
        const { resData } = this.state;
        let userId = localStorage.getItem('userId')
        let formatData = this.formatData();
        if(formatData.orgName.split(',').length != 3){
            message.error('地区选择必须精确到县级')
                return
        }
        const params = { ...formatData, userId, informationFormState: resData.informationFormState }
        console.log("resresresresresresresresres",params);
        Http.post(Request.userInfoAuth(), params, (obj) => {
            console.log("------userInfoAuth------", obj);
            if (obj.code == 200) {
                message.success(obj.msg);
                this.getInstitutionInfo()
            } else {
                message.error(obj.msg);
                // setTimeout(() => {
                //     this.props.history.push('/login')
                // }, 1000);
            }
            this.setState({ isInfoEdit: false });
        });
        console.log("------userInfoAuth------", params);
    }

    updateInstitutionInfo() {
        const { resData } = this.state;
        let userId = localStorage.getItem('userId')
        let formatData = this.formatData();
        if(formatData.orgName.split(',').length != 3){
            message.error('地区选择必须精确到县级')
                return
        }
        const params = { ...formatData, userId, id: resData.id, informationFormState: resData.informationFormState }
        Http.post(Request.userInfoUpdate(), params, (obj) => {
            console.log("------userInfoUpdate------", obj);
            if (obj.code == 200) {
                message.success(obj.msg);
                this.getInstitutionInfo()
                // this.setState({
                // });
            } else {
                message.error(obj.msg);
                // setTimeout(() => {
                //     this.props.history.push('/login')
                // }, 1000);
            }
            this.setState({ isInfoEdit: false });
        });
        console.log("------userInfoUpdate------", params);
    }

    //收集表单数据
    formatData() {

        const { formConfig1, materiList1,areaInfo } = this.state;
        let obj = {};
        formConfig1.forEach(item => obj[item.name] = item.value)
        obj.sybPhotoManages = materiList1
        if(areaInfo.countyId){
            //     message.error('地区选择必须精确到县级')
            //     return
            // }else{
                console.log('areaInfo',areaInfo);
                let v= ''
                if(areaInfo.countyId){
                    v = `${areaInfo.provinceId},${areaInfo.cityId},${areaInfo.countyId}`
                }else if(areaInfo.cityId){
                    v = `${areaInfo.provinceId},${areaInfo.cityId}`
                }else if(areaInfo.provinceId){
                    v = `${areaInfo.provinceId}`
                }
                obj.orgId = v
            }
        console.log("------formatData------", obj);
        return obj
    }

    // handleVerify(type) {
    //     console.log("------handleVerify------");
    //     this.setState({ isMateriUpload: false });

    // }


    delImg(index) {
        const { materiList1 } = this.state;
        console.log("delImg", index);
        materiList1.splice(index, 1);
        this.setState({ materiList1 });
    }

    handleUploadChange = (info) => {
        const { materiList1 } = this.state
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
        }

        if (info.file.status === 'done') {
            let photoUrl = info.file.response.data.url
            materiList1.push({ photoUrl })
            this.setState({ materiList1 })
            // getBase64(info.file.originFileObj, (url) => {
            //   this.setState({ loading: false, imageUrl: url })
            // });
            // message.success(`${info.file.name} file uploaded successfully`);
            message.success(`上传成功`);
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    }

    authStatus = () => {
        const { informationFormState } = this.state;
        let arr = ['认证中', '认证通过', '未通过认证']
        return arr[informationFormState]
    }

    render() {
        const { history } = this.props;
        const { materiList1, formConfig1, isInfoEdit, informationFormReason, informationFormState } = this.state;

        return (
            <div className="user_info">
                {/* <div className="left_nav">
                    <Nav
                        defaultActive={'1'}
                        history={history}
                        dataList={navRouter}
                    />
                </div> */}
                <div className="right_cont">
                    <div className={isInfoEdit ? 'info_edit' : ''}>
                        <div className={['base_info', isInfoEdit ? '' : 'base_info_edit'].join(' ')}>
                            <div className="base_info_title">基本信息</div>
                            {isInfoEdit
                                ? <RenderForm dataList={formConfig1} onChange={this.handleChange.bind(this)} onChange2={this.handleChange2.bind(this)} handleCancel={this.handleCancel.bind(this, 'form')} handleSave={this.handleSave.bind(this, 'form')}>
                                    {(props) => <RenderFormItem  {...props} />}
                                </RenderForm>
                                : <EchoForm dataList={formConfig1} />
                            }
                            <div
                                className="edit_info_btn"
                                onClick={() => this.setState({ isInfoEdit: true })}
                            >
                                修改信息
                            </div>
                        </div>
                        <div className={["cert_materi", isInfoEdit ? "cert_materi_edit" : ''].join(' ')}>
                            <div className="cert_title">退役证明材料</div>
                            <div className={['materi_list', isInfoEdit ? 'materi_list_upload' : ''].join(' ')}>
                                {materiList1.length > 0 && materiList1.map((item, index) => {
                                    console.log('itemitemitem',item);
                                    
                                    return (
                                        <div className="item_img" key={Math.random()}>
                                            <img src={item.photoUrl} alt="" />
                                            <span className='del_img_btn' onClick={() => this.delImg(index)}>
                                                <img src={cancelIcon} alt="" />
                                            </span>
                                        </div>
                                    )
                                })}
                                {materiList1.length <= 3 && isInfoEdit && (
                                    <Upload {...uploadProps} onChange={this.handleUploadChange}>
                                        <div className='upload_materi'>
                                            <div className="upload_img">
                                                <img src={uploadIcon} alt="" />
                                                <span className=''>点击上传</span>
                                            </div>
                                        </div>
                                    </Upload>
                                )
                                }
                            </div>
                            {/* <div className="upload_materi_btn">
                                <Button
                                    size="small"
                                    type="primary"
                                    className="upload_btn"
                                    onClick={() => this.setState({ isInfoEdit: true })}
                                >
                                    上传材料
                                </Button>
                            </div> */}
                            {isInfoEdit && (
                                <div className="cancel_verify">
                                    <button
                                        className="cancel_btn"
                                        onClick={this.handleCancel.bind(this, 'upload')}
                                    >
                                        取消
                                    </button>
                                    <button
                                        className="verify_btn"
                                        onClick={this.handleSave.bind(this, 'upload')}
                                    >
                                        提交
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="cert_results">
                        <div className="base_info_title">认证结果</div>
                        {
                            informationFormState !== ''
                                ? <div className={['result_content_pending', 'result_content_success', 'result_content_failed'][informationFormState]}>{this.authStatus()}</div>
                                : <div className="unload_materi">还未上传认证材料！</div>
                        }
                        {
                          informationFormReason && <div className="results_reason">原因：{informationFormReason}</div>
                        }

                    </div>
                </div>
            </div>
        );
    }
}
